import { getFlag } from '@nx/launch-darkly-service';
import { Navigate, Route, Routes } from 'react-router';

import { AccountPage } from './account-page';
import { ApiKeysLayout } from './api-keys';
import { PreferencesLayout } from './preferences';
import { ProfileLayout } from './profile';

export function AccountRoutes() {
  const isUpxConsistencyEnabled = getFlag('upxConsistency', false);

  if (isUpxConsistencyEnabled) {
    return (
      <Routes>
        <Route path="*" element={<AccountPage />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="profile" element={<ProfileLayout />} />
      <Route path="api-keys" element={<ApiKeysLayout />} />
      <Route path="preferences" element={<PreferencesLayout />} />
      <Route path="*" element={<Navigate to="profile" replace />} />
    </Routes>
  );
}
